/**
 * @fileoverview Eligible My Page reassignees query hook.
 * @description Lists the people the caller may name as a target's new assignee (GET
 * /sales/targets/{targetId}/eligible-reassignees). It is advisory: Reassign and Request Target
 * Reassignment recheck the choice, and the backend refuses the list for a target that is closed,
 * completed or outside the caller's reach.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { useQuery } from '@tanstack/react-query'

import { SALES_CRM_QUERY_KEYS } from '@/features/sales/constants/prospects-query-keys.constants'
import { getEligibleReassignees } from '@/features/sales/services/my-page-targets.service'

/**
 * @description Fetches who a target may be reassigned to.
 * @param {string} targetId - The target.
 * @returns {ReturnType<typeof useQuery>} The query (data is the people, ordered by name).
 */
export function useEligibleMyPageReassignees(targetId: string) {
  return useQuery({
    queryKey: SALES_CRM_QUERY_KEYS.myPageReassignees(targetId),
    queryFn: () => getEligibleReassignees(targetId),
    retry: false,
    gcTime: 0,
  })
}
